/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Go_Offline_MsgInputs */



/**
* | output |
* | --- |
* | "Run this tournament from this device alone while offline." |
*
* @param {Offline_Go_Offline_MsgInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const offline_go_offline_msg = /** @type {((inputs?: Offline_Go_Offline_MsgInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Go_Offline_MsgInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gérez ce tournoi depuis cet appareil uniquement, en mode hors ligne.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Gestione este torneo solo desde este dispositivo mientras está sin conexión.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Gerencie este torneio somente a partir deste dispositivo enquanto offline.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gestisca questo torneo solo da questo dispositivo mentre è offline.")
	return /** @type {LocalizedString} */ ("Run this tournament from this device alone while offline.")
});